module.exports = __webpack_public_path__ + "images/feature/weekly-report-2-36133c684386d1cb92f263fdd1fed00b.png";